module.exports = __webpack_public_path__ + "static/media/chadwicks-group.77082218.png";